import { render, staticRenderFns } from "./simple-filter.vue?vue&type=template&id=b33fbd18&"
import script from "./simple-filter.vue?vue&type=script&lang=ts&"
export * from "./simple-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b33fbd18')) {
      api.createRecord('b33fbd18', component.options)
    } else {
      api.reload('b33fbd18', component.options)
    }
    module.hot.accept("./simple-filter.vue?vue&type=template&id=b33fbd18&", function () {
      api.rerender('b33fbd18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/filters/simple-filter.vue"
export default component.exports